import React from 'react';
import './Company.css';

const Company = () => {
  return (
    <div className="company-page">
      <div className="page-header">
        <div className="container">
          <h1>運営会社</h1>
        </div>
      </div>
      
      <section className="section">
        <div className="container">
          <div className="company-info">
            <div className="info-section">
              <h2>会社概要</h2>
              <table className="info-table">
                <tbody>
                  <tr>
                    <th>社名</th>
                    <td>株式会社ゴルマチ</td>
                  </tr>
                  <tr>
                    <th>設立</th>
                    <td>2024年9月</td>
                  </tr>
                  <tr>
                    <th>事業内容</th>
                    <td>ゴルフ特化型マッチングアプリ開発及び運営</td>
                  </tr>
                  <tr>
                    <th>代表者</th>
                    <td>長濱 貴也</td>
                  </tr>
                  <tr>
                    <th>所在地</th>
                    <td>〒107-0062<br />東京都港区南青山3丁目1番36号青山丸竹ビル6F</td>
                  </tr>
                  <tr>
                    <th>問合せ</th>
                    <td>support@golmachi.net</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Company;